import * as yup from 'yup';

export const CreateOfoCodeCategoryValidationSchema = yup.object().shape({
    jobTitle: yup.string().required('Job Title cannot be empty').max(200, 'Job title must be less than 200 characters'),
    majorGroup: yup.string().required('Please select a Major Group').nullable(),
    subMajorGroup: yup.string().required('Please select a Sub-Major Group').nullable(),
    minorGroup: yup.string().required('Please select a Minor Group').nullable(),
    unitGroup: yup.string().required('Please select a Unit Group').nullable(),
    occupationGroup: yup.string().required('Please select a Occupational Group').nullable(),
    OfoCode: yup.string().matches(/^\d{6}$/, 'OFO Code must be 6 digits'),
});


